import { useEffect, useState } from 'react'
import axios from 'lib/axios'
import { IntegrationInstance } from 'models'

/* The tenant's instances, whose URI templates turn a member record into an origin link. */
export const useIntegrationInstances = () => {
  const [instances, setInstances] = useState<IntegrationInstance[]>([])

  useEffect(() => {
    let cancelled = false

    axios
      .get<{ instances: IntegrationInstance[] }>('/api/v3/integrations/configured')
      .then((res) => !cancelled && setInstances(res.data?.instances ?? []))
      .catch((error) => console.error(error))

    return () => {
      cancelled = true
    }
  }, [])

  return instances
}
